import axios from 'axios';
import Vue from 'Vue';
import commonObj from '../../services/common.js';
import {HTTP} from '../../services/api-service.js';
var common = new commonObj();

var HTTP1 = axios.create();
var baseUrl = common.baseURL + '/authentication/';
const loginStore={
    namespaced: true,
    actions:{
        login({commit}, param) {
            return new Promise((resolve, reject) => {
            	HTTP1.post(baseUrl + 'login', param.loginModel).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        refreshToken({commit}, param) {
            return new Promise((resolve, reject) => {
            	HTTP1.post(baseUrl + 'reauthenticatetoken').then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
        refreshMenu({ commit, state }, param) {
            return new Promise((resolve, reject) => {
              HTTP.post(baseUrl + 'refreshmenu').then(response => {
                  resolve(response);
                })
                .catch(e => {
                  reject(e);
                });
            });
        },
        getscrsec({ commit, state }, param) {
            return new Promise((resolve, reject) => {
              HTTP.post(baseUrl + 'getscrsec',{menuID: param.menuID}).then(response => {
                  resolve(response);
                })
                .catch(e => {
                  reject(e);
                });
            });
        },
    }
};
export default loginStore;